module.exports = __webpack_public_path__ + "media/images/new/icons/phone_buttons-699ef997d9c5639fd296c6e4a52a168e.png";